module.exports = __webpack_public_path__ + "static/drt4-c13b84ec211bd246bac3bc90248bd06f.jpg";